import { createClient } from "./http";
import { env } from "../config/env";

const api = createClient(env.ORDER_BASE_URL);

function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params || {}).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
}

export const couponsService = {
  async list(params = {}) {
    return api.get("/api/orders/admin/coupons", { params: cleanParams(params) });
  },

  async create(payload = {}) {
    return api.post("/api/orders/admin/coupons", payload);
  },

  async update(id, payload = {}) {
    return api.patch(`/api/orders/admin/coupons/${id}`, payload);
  },

  async setActive(id, isActive) {
    return api.patch(`/api/orders/admin/coupons/${id}/active`, { isActive });
  },

  async approve(id) {
    return api.post(`/api/orders/admin/coupons/${id}/approve`, {});
  },

  async reject(id, reason) {
    return api.post(`/api/orders/admin/coupons/${id}/reject`, { reason });
  },

  async delete(id) {
    return api.del(`/api/orders/admin/coupons/${id}`);
  },


  async usages(id, params = {}) {
    return api.get(`/api/orders/admin/coupons/${id}/usages`, { params: cleanParams(params) });
  },
};

export default couponsService;
